export { default } from "./updatePersonalInformation";
